<template>
  <div
    class="game-tr-input"
    :class="[
      { 'position-inherit': elementTopPosition ? false : true },
      { 'input-upper-style': inputType === 'index-upper' },
      { 'input-lower-style': inputType === 'index-lower' },
      { 'input-bouth-upper-style': inputType === 'index-bouth-upper' },
      { 'input-bouth-lower-style': inputType === 'index-bouth-lower' },
    ]"
    :style="setInputGameStyle()"
  >
    <mb-audio
      v-if="audioData.audioSrc"
      :item-audio="{
        audioSrc: audioData.audioSrc,
        position: 'absolute',
        audioCss: audioData.audioCss ? audioData.audioCss : { left: '-64px' },
      }"
    >
    </mb-audio>
    <input
      autocomplete="off"
      v-model="inputVal"
      type="text"
      placeholder=""
      class="inline-input tr-input-text"
      :class="[
        { 'inline-input-disabled': getInputData().block === true },
        { 'inline-input-correct': getInputData().inputStatus === 'correct' },
        { 'inline-input-wrong': getInputData().inputStatus === 'incorrect' },
        { 'inline-input-text-aling-center': elementTextAlign === 'center' },
        { 'inline-input-text-aling-left': elementTextAlign === 'left' },
        { 'inline-input-text-aling-right': elementTextAlign === 'right' },
      ]"
      :style="setInputStyle()"
      :maxlength="maxLength"
      :disabled="getInputData().block === true"
      @click="resetCheckStatus"
      @keyup.left="keyArrowLeft"
      @keyup.right="keyArrowRight"
      @keyup.up="keyArrowUp"
      @keyup.down="keyArrowDown"
      @input="signalChange"
    />
  </div>
</template>

<script>
/**
 * Pojedyńczy konfigurowalny input
 * @typedef {Object}  InputConfig
 *
 * @property {String}  id - ID inputa
 * @property {ImageData}  imageData - konfiguracja obrazka
 * @property {Array.<String>|String}  correct - tablica poprawnych odpowiedzi
 * @property {Boolean}  exclude - jeśli true dany input zostanie wyłączony z procesu sprawdzania (nie będzie brany pod uwagę)
 * @property {Number}  inputWidth  - szerokość inputów
 * @property {Number}  inputHeight - wysokość inputów
 * @property {Number}  inputFontSize - wielkość czcionki inputów
 * @property {Number}  inputFontStyle - styl czcionki w inputach
 * @property {Number}  inputMaxLength - maksymalna ilość znaków możliwyh do wprowadzenia
 * @property {Object} cssStyle - indywidualny styl CSS, którym można zmienić wygląd elementu
 *
 * @example
 *
 * (...)
 *
 *    {
 *      id: 'input_1',
 *      pos: {
 *        y: 469,
 *        x: 306,
 *      },
 *      inputWidth: 1301,
 *      inputHeight: 118,
 *      correct: ['test1','test2'],
 *      exclude: true,
 *       cssStyle: {
 *        width: '76%',
 *        position: 'absolute',
 *        top: '100px',
 *        left: '150px',
 *      },
 *    },
 *
 * (...)
 */

/**
 * Konfigurowalny input
 * @type {InputConfig}
 * @name inputConfig
 */
var inputConfig;

import _ from 'lodash';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import * as utils from '../../Utils/inputUtils';
export default {
  name: 'tr-input',
  components: { MbAudio },
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    audioData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    trInputValue: {
      type: null,
      default: '',
    },
    trInputValueIndex: {
      type: null,
      default: 0,
    },
    offsetHorizontal: {
      type: Number,
      default: 0,
    },
    offsetVertical: {
      type: Number,
      default: 0,
    },
    inputWidth: {
      type: null,
      default: 'auto',
    },
    inputHeight: {
      type: null,
      default: 'auto',
    },
    inputType: {
      type: String,
      default: 'normal',
    },
    inputFontStyle: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
    inputCheckStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
    maxLength: {
      type: null,
      default: 255,
    },
    inputFontSize: {
      type: null,
      default: 44,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  created() {},
  mounted() {
    // if (this.inputType != 'normal') {
    //   this.maxLength = 1;
    // }
  },
  methods: {
    signalChange: function ($event) {
      if (!_.isEmpty($event.target.value)) {
        this.$emit('changeElement', $event, this.config.id);
      }
    },
    keyArrowLeft($event) {
      this.$emit('keyArrowLeft', $event, this.config.id);
    },
    keyArrowRight($event) {
      this.$emit('keyArrowRight', $event, this.config.id);
    },
    keyArrowUp($event) {
      this.$emit('keyArrowUp', $event, this.config.id);
    },
    keyArrowDown($event) {
      this.$emit('keyArrowDown', $event, this.config.id);
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getInputData() {
      if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
        return this.trInputValue[this.trInputValueIndex];
      } else {
        return this.trInputValue;
      }
    },
    setInputGameStyle() {
      return {
        top: `${this.elementTopPosition}`,
        left: `${this.elementLeftPosition}`,
        width: `${this.elementWidth}`,
        height: `${this.elementHeight}`,
        'border-radius': `${this.borderRadius}`,
      };
    },
    setInputStyle() {
      let checkStyle = {};
      if (this.getInputData().inputStatus === 'correct') {
        checkStyle = this.inputCheckStyle;
      }
      return [
        {
          'font-family': `${this.inputFontStyle}`,
          'font-size': `${this.elementInputFontSize}`,
          'border-radius': `${this.borderRadius}`,
          [`padding-${this.elementTextAlign}`]: `${this.elementTextPadding}`,
          border: 'none',
          background: `${this.backgroundColor}`,
        },
        checkStyle,
      ];
    },
  },
  computed: {
    inputVal: {
      get() {
        if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
          return this.trInputValue[this.trInputValueIndex].val;
        }
        return this.trInputValue.val;
      },
      set(newValue) {
        if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
          if (!this.trInputValue[this.trInputValueIndex].block) {
            this.trInputValue[this.trInputValueIndex].val = newValue;
          }
        } else {
          if (!this.trInputValue.block) {
            this.trInputValue.val = newValue;
          }
        }
        // this.$emit('changeElement',$event);
      },
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.inputWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.inputHeight);
    },
    elementInputFontSize() {
      if (_.isNumber(this.inputFontSize)) {
        return `${this.inputFontSize}px`;
      } else {
        return this.inputFontSize;
      }
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
      }
      return align;
    },
    elementTextPadding() {
      let padding = '0';
      if (this.config && this.config.padding) {
        padding = this.config.padding;
      }
      return padding;
    },
    borderRadius() {
      let borderRadius = '0%';
      if (this.config && this.config.borderRadius) {
        borderRadius = this.config.borderRadius;
      }
      return borderRadius;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
$indexedInput: 2.5rem;
$indexedFontSize: 1.6rem;
$rightMargin: 0.5rem;

.game-tr-input {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $bacgroundColor;
}
input {
  font-family: $gameFontFamily;
}
.input-indexed {
  position: relative !important;
  font-size: $indexedFontSize;
  width: $indexedInput !important;
  height: $indexedInput !important;
}

.input-upper-style {
  top: -2.4rem !important;
  left: 0.3rem !important;
  margin-right: $rightMargin !important;
  @extend .input-indexed;
}
.input-lower-style {
  top: 1.5rem !important;
  left: 0.3rem !important;
  margin-right: $rightMargin !important;
  @extend .input-indexed;
}
.input-bouth-upper-style {
  top: -2.4rem !important;
  left: 0.5rem !important;
  @extend .input-indexed;
}
.input-bouth-lower-style {
  top: 1rem !important;
  left: -2rem !important;
  margin-right: $rightMargin !important;
  @extend .input-indexed;
}
.position-inherit {
  position: inherit;
}
</style>
